import React, {useState} from "react";
import * as palette from "../Variables";
import HomeIntro from "../components/HomeIntro";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import HomeWorkListing from "../components/HomeWorkListing";
import Placeholder from "../img/placeholder.jpg";
import styled from "styled-components";
import { BrowserRouter, Routes, Route, Link } from 'react-router';
import SouthwestTile from "../img/southwest/southwest-tile.png";
import DignifiTile from "../img/dignifi/dignifi-tile.png";
import SmartHomeTile from "../img/smart-home/smart-home-tile.png";
import InsightTile from "../img/insight/insight-tile.jpg";

const MyWorkSection = styled.section`
    padding: 22px 16px;

    &.first {
        padding: 44px 16px 22px 16px;
    }

    &.last {
        padding: 22px 16px 44px 16px;
    }

    @media (min-width: 768px) {
        padding: 36px 24px;

        &.first {
            padding: 72px 24px 36px 24px;
        }

        &.last {
            padding: 36px 24px 72px 24px;
        }
    }

    h2 {
        margin-bottom: 24px;

        @media (min-width: 768px) {
            margin-bottom: 24px;
        }
    }

    .row {
        justify-content: space-between;
    }

    .work-listing-container {
        display: flex;
        row-gap: 36px;

        @media (min-width: 768px) {
            row-gap: 64px;
        }
    }
`;

const Work = () => {

    return (
        <main>
            <MyWorkSection>
                <HomeIntro></HomeIntro>
            </MyWorkSection>
            <MyWorkSection className={"last"}>
                <Container>
                    <Row>
                        <Col>
                            <h2 className={"h3"}>My work</h2>
                        </Col>
                    </Row>
                    <Row className={"work-listing-container"}>
                        <Col xs={12} sm={6}>
                            <HomeWorkListing
                                className={"left"}
                                href={"/southwest-app-redesign"}
                                img={SouthwestTile}
                                alt={"Three screens from the redesigned Southwest Airlines app"}
                                title={"Southwest Airlines"}
                                label={"App redesign (concept)"}
                                description={"A concept project focused on improving navigation, information hierarchy, and visual design in the Southwest Airlines app."}>
                            </HomeWorkListing>
                        </Col>
                        <Col xs={12} sm={6}>
                            <HomeWorkListing
                                className={"right"}
                                href={"/dignifi-app-design"}
                                img={DignifiTile}
                                alt={"Three screens from the Dignifi app"}
                                title={"Dignifi"}
                                label={"App design"}
                                description={"An app that puts users in control of their data with a customizable dashboard, goal tracking, and flexible privacy tools."}>
                            </HomeWorkListing>
                        </Col>
                        <Col xs={12} sm={6}>
                            <HomeWorkListing
                                className={"left"}
                                href={"/insight-ar-app-design"}
                                img={InsightTile}
                                alt={"Prototype of the InSight AR device and one screen from the InSight app"}
                                title={"InSight"}
                                label={"AR experience and app design"}
                                description={"A wearable augmented reality device and app designed to help neurodivergent users recognize emotions and navigate social interactions."}>
                            </HomeWorkListing>
                        </Col>
                        <Col xs={12} sm={6}>
                            <HomeWorkListing
                                className={"right"}
                                href={"/smart-home-infographic"}
                                img={SmartHomeTile}
                                alt={"Mobile and desktop views of the Renesas Smart Home infographic"}
                                title={"Renesas Smart Home"}
                                label={"Interactive infographic"}
                                description={"An infographic detailing current IoT trends and the benefits and applications of Renesas' smart home solutions"}>
                            </HomeWorkListing>
                        </Col>
                    </Row>
                </Container>
            </MyWorkSection>
        </main>
    )
}

export default Work;